import { render, staticRenderFns } from "./AuthorsTable.vue?vue&type=template&id=1eb2dbe4&"
import script from "./AuthorsTable.vue?vue&type=script&lang=js&"
export * from "./AuthorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports